// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__e5LC3","resendInfoText":"OnGoingPaymentBox_resendInfoText__3uvOH"};